import { z } from 'zod';

export const schemaChatUnresolvedPayload = z.object({});

export type Schema_ChatUnresolvedPayload = z.infer<typeof schemaChatUnresolvedPayload>;
